import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentsProcessorsWrapper = () => {
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/commerce-hub/InAppPaymentsProcessorsSection`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/commerce-hub/PublicPaymentsProcessorsSection`)
  });
};
export default PaymentsProcessorsWrapper;